export default __webpack_public_path__ + "static/media/bannersMenuIcon.89ebec14.svg";